export const enumPermisosPinesColpatriaCRC = Object.freeze({
  CREAR_PIN: 6014,
  PETICION_ANULACION: 6015,
  ANULACION_PINES: 6013,
  REPORTE_GENERAL_PIN_CRC: 6016,
});
